.main_content {
	margin-right: 20px !important;
	margin-left: 20px !important;
	margin-top: 5px;

	.body {
		padding-top: 1em;
		min-height: 80vh;
		max-height: 82vh;
		width: 100%;
		padding-bottom: 1rem;
		box-shadow: 5px 5px 10px #dfe1e6;
		background-color: white;
		border-radius: 10px;
		display: flex;
		flex-direction: column;

		button {
			background-color: #7fb02f;
			border: #fff 1px solid;
			color: #fff;
			border-radius: 15px;
			font-size: 0.8rem;
			padding: 0.5em 1rem;
			margin-bottom: 1rem;

			&:hover {
				background-color: #5a8217;
				border: #7fb02f 1px solid;
				color: #fff;
			}
			.add_icon {
				width: 1em;
				height: 1em;
				margin-left: 1rem;
				cursor: pointer;
			}
		}

		.content {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			overflow-y: auto;
			height: 100%;
			width: 100%;

			&::-webkit-scrollbar {
				width: 5px;
			}

			&::-webkit-scrollbar-track {
				background: #f1f1f1;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #a8a8a8;
				border-radius: 15px;
			}

			.category_card {
				background-color: #f1f1f1;
				box-shadow: 5px 5px 10px #dfe1e6;
				border-radius: 10px;
				width: 30%;
				margin: 1rem;
				padding: 1rem;
				cursor: pointer;
				text-align: center;
				color: #515151;

				.icon {
					width: 3rem;
					height: 3rem;
					fill: #515151;
				}
				h4 {
					padding: 1rem;
					color: #7fb02f;
				}
				&:hover {
					background-color: #7fb02f;
					color: #fff;
					h4 {
						color: #fff;
					}
				}
			}
		}
	}

	.accordion {
		width: 100%;
		margin-bottom: 1rem;

		:global(.accordion-item) {
			border: 1px solid #dfe1e6;
			border-radius: 8px;
			margin-bottom: 0.5rem;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			overflow: hidden;
		}

		.accordion_header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			padding: 1rem;
			position: relative;

			:global(.accordion-button) {
				flex: 1;
				cursor: pointer;
				padding: 0;
				border: none;
				background: transparent;
				box-shadow: none;

				&:not(.collapsed) {
					background-color: transparent;
					box-shadow: none;
				}

				&:focus {
					box-shadow: none;
					border: none;
				}

				&::after {
					margin-left: auto;
				}
			}

			&:hover {
				background-color: #f8f9fa;
				p {
					color: #515151;
				}
			}

			h5 {
				color: #7fb02f;
				display: flex;
				align-items: center;
				margin: 0;
			}

			p {
				margin: 0.25rem 0 0 0;
			}
		}

		.option_container {
			display: flex;
			align-items: center;
			gap: 0.75rem;
			padding-left: 1rem;

			.edit_icon {
				width: 1.25rem;
				height: 1.25rem;
				fill: #515151;
				cursor: pointer;
				visibility: visible;
				transition: fill 0.2s;

				&:hover {
					fill: #5a8217;
				}
			}

			.close_icon {
				width: 1.25rem;
				height: 1.25rem;
				fill: #515151;
				cursor: pointer;
				visibility: visible;
				transition: fill 0.2s;

				&:hover {
					fill: #f52828;
				}
			}
		}

		.question_list {
			padding: 1em;

			li {
				position: relative;
				font-size: 1.2rem;
				padding: 1rem 0.5rem;
				list-style: none;
				border: 1px solid #a8a8a8;
				border-radius: 5px;
				margin-bottom: 0.3rem;
				p {
					margin: 0;
				}

				.option_question_container {
					position: absolute;
					right: 10px;
					top: 15px;

					.edit_icon_question {
						position: relative;
						width: 1rem;
						height: 1rem;
						fill: #515151;
						cursor: pointer;
						margin-left: 0.5rem;
						visibility: hidden;
					}
					.close_icon_question {
						width: 1rem;
						height: 1rem;
						fill: #515151;
						cursor: pointer;
						visibility: hidden;
					}
				}
				&:hover {
					background-color: #e6e6e6;
					border-radius: 5px;
					cursor: pointer;
					&:hover {
						.edit_icon_question {
							width: 1rem;
							height: 1rem;
							fill: #515151;
							cursor: pointer;
							visibility: visible;
							&:hover {
								fill: #5a8217;
							}
						}
						.close_icon_question {
							width: 1rem;
							height: 1rem;
							fill: #515151;
							cursor: pointer;
							visibility: visible;
							margin-left: 0.5rem;
							&:hover {
								fill: #f52828;
							}
						}
					}
				}
			}
		}
	}
}
.base_ckeditor {
	padding: 1rem;
	width: 100%;
	figure {
		width: 90%;

		div {
			width: 95%;
		}
		img {
			width: 100%;
		}
	}
	img {
		width: 100%;
	}
}
//Form

.form_button {
	display: flex;
	justify-content: flex-end;

	.button {
		width: 6rem !important;
		border-radius: 20px;
	}
}
